// Generated by ReScript, PLEASE EDIT WITH CARE


var steppers = {
  hd: {
    label: {
      TAG: /* Text */0,
      _0: "Base Details"
    },
    subtitle: undefined,
    name: /* BaseDetail */0
  },
  tl: {
    hd: {
      label: {
        TAG: /* Text */0,
        _0: "Slab Details"
      },
      subtitle: undefined,
      name: /* SlabDetails */1
    },
    tl: {
      hd: {
        label: {
          TAG: /* Text */0,
          _0: "Preview Campaign"
        },
        subtitle: undefined,
        name: /* Preview */2
      },
      tl: /* [] */0
    }
  }
};

export {
  steppers ,
  
}
/* No side effect */
